export const TIKTOK_CONTENT_TYPE = {
  individual: 'individual',
  channel: 'channel',
};
